<template>
  <b-modal :id="modalId" :ref="modalId" @show="onClear" size="xl">
    <template slot="modal-header">
      <h5 class="modal-title">{{ (isAddPart) ? 'Add Vendor RMA Line' : 'Edit Vendor RMA Line' }}</h5>
    </template>
    <div class="animated fadeIn requirements--requirements-list h-100">
      <div class="card-body d-flex flex-column">
        <b-row>
          <b-col cols="2">
            <dt>Purchase Order No</dt>
            <dd>{{ vendorrma.purchaseOrderId }}</dd>
          </b-col>
          <b-col cols="2">
            <dt>Company</dt>
            <dd>{{ vendorrma.companyName }}</dd>
          </b-col>
          <b-col cols="2">
            <dt>Purchase Order Date</dt>
            <dd>{{ vendorrma.poDate | date }}</dd>
          </b-col>
        </b-row>
        <br/>
        <div v-if="isAddPart">
          <h5>Purchase Order Lines</h5>
          <b-row>
            <b-col>
              <div class="grid-container">
                <grid-component
                  isResizable
                  isReorderable
                  :item-data="itemLineData"
                  :fields="lineFields"
                  :gridId="gridLineId"
                  :handleRowClick="onRowLineClick"
                />
              </div>
            </b-col>
          </b-row>
          <h5>
            Inventory Used
            <i v-show="isLoadingInventory" class="fa fa-spinner fa-pulse fa-fw"></i>
          </h5>
          <b-row>
            <b-col>
              <div class="grid-container">
                <grid-component
                  isResizable
                  isReorderable
                  :gridId="gridInventoryId"
                  :itemData="inventoryItemData"
                  :fields="inventoryField"
                  :optionsField="rmaReasons"
                  :checkBoxValues="checkedInventoryReturnedIds"
                  :autoCheckBy="'qtyReturning'"
                  @checkedItem="checkedInventoryReturnedIds=$event"
                />
              </div>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <div class="d-flex flex-column">
            <b-row>
              <b-col cols="9">
                <b-row>
                  <b-col cols="4">
                    <b-form-group label="Part #" class="mr-2">
                      <b-form-input v-model="vrmaPoLine.partNumber" :disabled="true" class="form-control"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-group label="Description" class="mr-2" width="500">
                      <b-form-input v-model="vrmaPoLine.description" :disabled="true" class="form-control"/>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <b-form-group label="Vendor PN" class="mr-2">
                      <b-form-input v-model="vrmaPoLine.vendorPN" :disabled="true" class="form-control"/>
                    </b-form-group>
                    <b-form-group label="Internal PN" class="mr-2">
                      <b-form-input v-model="vrmaPoLine.internalPN" :disabled="true" class="form-control"/>
                    </b-form-group>
                    <b-form-group label="NSN" class="mr-2">
                      <b-form-input v-model="vrmaPoLine.nsnNumber" :disabled="true" class="form-control"/>
                    </b-form-group>
                    <b-form-group label="Harmonized Code" class="mr-2">
                      <b-form-input v-model="vrmaPoLine.harmonizedCode" :disabled="true" class="form-control"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-group label="Mfr" class="mr-2">
                      <b-form-input v-model="vrmaPoLine.mfgName" :disabled="true" class="form-control"/>
                    </b-form-group>
                    <b-form-group label="Category" class="mr-2">
                      <b-form-input v-model="vrmaPoLine.categoryName" class="form-control" :disabled="true"/>
                    </b-form-group>
                    <b-form-group label="Class" class="mr-2">
                      <b-form-input v-model="vrmaPoLine.className" class="form-control" :disabled="true"/>
                    </b-form-group>
                    <b-form-group label="Ordered" class="mr-2">
                      <b-form-input v-model="vrmaPoLine.ordered" class="form-control" :disabled="true"/>
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-group label="Capacitor" class="mr-2">
                      <b-form-input v-model="vrmaPoLine.capacitor" :disabled="true" class="form-control"/>
                    </b-form-group>
                    <b-form-group label="Date Code" class="mr-2">
                      <b-form-input v-model="vrmaPoLine.dateCode" class="form-control" :disabled="true"/>
                    </b-form-group>
                    <b-form-group label="Reason" class="mr-2">
                      <b-form-select v-model="vrmaPoLine.returnReasonId" class="form-control">
                        <option v-for="option in sortSelect(rmaReasons)" :key="option.name" :value="option.id">
                          {{ option.name }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                    <b-form-group label="Returned" class="mr-2">
                      <b-form-input v-model="vrmaPoLine.returned" class="form-control"/>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="8">
                    <b-form-group label="Comments" class="mr-2">
                      <b-textarea v-model="vrmaPoLine.comments" class="form-control"/>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="3">
                <b-col>
                  <b-form-group label="Lot Code" class="mr-2">
                    <b-form-input v-model="vrmaPoLine.lotCode" :disabled="true" class="form-control"/>
                  </b-form-group>
                  <b-form-group label="Revision" class="mr-2">
                    <b-form-input v-model="vrmaPoLine.revision" class="form-control" :disabled="true"/>
                  </b-form-group>
                  <b-form-group label="Condition" class="mr-2">
                    <b-form-input v-model="vrmaPoLine.condition" class="form-control" :disabled="true"/>
                  </b-form-group>
                  <b-form-group label="Cost" class="mr-2">
                    <b-form-input v-model="vrmaPoLine.cost" class="form-control" :disabled="true"/>
                  </b-form-group>
                  <b-form-group label="Total" class="mr-2">
                    <b-form-input v-model="vrmaPoLine.total" class="form-control" :disabled="true"/>
                  </b-form-group>
                </b-col>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <template slot="modal-footer">
      <b-button variant="primary" @click="saveVRMALine" :disabled="isSaving">
        <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save
      </b-button>
      <b-button @click="$bvModal.hide(modalId)">Cancel</b-button>
    </template>
  </b-modal>
</template>

<script>
  import { mapMutations, mapActions, mapGetters, mapState } from 'vuex';
  import GridSettings from '@/shared/components/GridSettings';
  import { prepareColumnsData } from '@/shared/helpers';
  import { date } from '@/shared/filters';
  import debounce from 'lodash/debounce';
  import gridFields from '@/pages/PurchaseOrders/components/PurchaseOrderLines/fields';
  import PurchaseOrderLines from '@/pages/PurchaseOrders/components/PurchaseOrderLines';
  import { PAGE_SIZE, SAVE_SETTINGS_DELAY, GRID_ID } from '@/shared/constants';
  import GridComponent from '@/shared/components/GridComponent';
  import inventoryUsedField from '@/pages/Customerrmas/components/add/inventoryUsedField';

  export default {
    props: {
      isAddPart: {
        type: Boolean,
        default: false,
      },
      vrmaPoLine: {
        type: Object,
        default: () => {
        },
      },
      vrmaId: {
        type: [Number, String],
        default: 0,
      },
    },
    components: {
      PurchaseOrderLines,
      GridSettings,
      GridComponent,
    },
    filters: {
      date,
    },
    data: () => ({
      inventoryField: inventoryUsedField,
      lineFields: gridFields,
      prepareColumnsData,
      selectedRowItemId: 0,
      date,
      PAGE_SIZE,
      gridLineId: GRID_ID.PURCHASE_ORDER_LINES_FOR_VENDOR_RMA,
      gridInventoryId: GRID_ID.RMA_INVENTORY,
      poLinesSelected: {},
      checkedInventoryReturnedIds: [],
      isLoadingInventory: false,
      modalId: 'rma-poline-modal',
      isSaving: false,
    }),
    computed: {
      ...mapGetters('account', ['gridSettingsById']),
      ...mapGetters('vendorrmas', ['vendorrma']),
      ...mapGetters('lookup', ['rmaReasons']),
      ...mapGetters('inventory', ['inventoryListFiltered']),
      ...mapGetters('purchaseOrderLines', ['purchaseOrderLines']),
      gridSettings() {
        return this.gridSettingsById(this.gridId);
      },
      inventoryItemData() {
        if (this.inventoryListFiltered.length === 0) return [];

        return this.inventoryListFiltered.map((inventory) => ({
          ...inventory,
          quantityPulled: this.poLinesSelected.qtyReceived,
          qtyReturning: 0,
          rmaReasonId: 0,
          comments: null,
          selected: false,
        }));
      },
      itemLineData() {
        return this.purchaseOrderLines.map((item) => ({ ...item, selected: item.id === this.selectedRowItemId }));
      },
    },
    methods: {
      ...mapActions('account', ['saveGridSettings']),
      ...mapActions('inventory', ['getInventoryFiltered']),
      ...mapActions('vendorrmas', ['onSaveVRMALine', 'onUpdateVRMALine', 'getLinesById']),
      // ...mapMutations('inventory', ['setInventoryListFiltered']),
      ...mapMutations('inventory',{inventorySetItem: 'setItem'}),
        async onRowLineClick(e) {
        this.selectedRowItemId = e.dataItem.id;
        this.poLinesSelected = this.itemLineData.find(item => item.id == this.selectedRowItemId);
        try {
          this.isLoadingInventory = true;
          await this.getInventoryFiltered({
            purchaseOrderLineId: this.selectedRowItemId,
          });

          this.isLoadingInventory = false;
        }catch (e) {
          this.isLoadingInventory = false;
        }
      },
      onClear() {
        if (this.isAddPart) {
          this.selectedRowItemId = 0;
          // this.setInventoryListFiltered([]);
          this.inventorySetItem({ resource:'inventoryListFiltered', payload: [] });
        }
      },
      getInventoryReturned() {
        return this.inventoryItemData.filter((item) => {
          return this.checkedInventoryReturnedIds.some((id) => {
            return id == item.id;
          });
        }).map(items => ({
          inventoryId: items.id,
          qtyReturning: items.qtyReturning,
          reasonId: items.rmaReasonId,
          comments: items.comments,
        }));
      },
      async saveVRMALine() {
        try {
          this.isSaving = true;
          if (this.isAddPart) {
            await this.onSaveVRMALine({
              vendorRmaId: this.vrmaId,
              items: this.getInventoryReturned(),
              purchaseOrderLineId: this.selectedRowItemId,
            });
            this.$snotify.success('Created Vendor RMA Lines', 'Vendor RMA Lines');
          } else {
            await this.onUpdateVRMALine(this.vrmaPoLine);
            this.$snotify.success('Updated Vendor RMA Lines', 'Vendor RMA Lines');
          }
          this.isSaving = false;
          await this.getLinesById(this.vrmaId);
          this.$emit('onRefresh');
          this.$bvModal.hide(this.modalId);
        }catch (e) {
          this.isSaving = false;
        }
      },
    },
  };
</script>
<style scoped>
  .create-po-grid {
    height: auto !important;
  }
</style>
